import { Component, OnInit } from "@angular/core";
import { CustomAlertService } from "../../models/custom-alert.service";
import { RememberService } from "../../remember/remember.service";

@Component({
  selector: "ab-custom-alert",
  templateUrl: "./custom-alert.component.html",
})
export class CustomAlertComponent implements OnInit {
  private readonly hideAlertKey: string = "hide-custom-alert";
  private readonly fifteenMinutes: number = 15 * 60 * 1000;
  public show: boolean = false;
  public content: string = "";
  public ctaText: string = "";
  public ctaLink: string = "";

  constructor(
    private customAlertService: CustomAlertService,
    private remember: RememberService,
  ) { }

  public ngOnInit() {
    this.show = false;
    if (this.isHidden()) { return; }

    this.customAlertService.get().subscribe(data => {
      if (data === undefined) {
        this.hideAlert();
        return;
      }

      if (data.hasOwnProperty("content")) {
        this.content = data.content;
        this.ctaText = data.cta_text;
        this.ctaLink = data.cta_link;
        this.show = true;
      } else {
        this.hideAlert();
      }
    });
  }

  public onCtaClicked() {
    window.open(this.ctaLink, "_blank");
    this.customAlertService.ctaClicked().subscribe();
  }

  public onDismissed() {
    this.hideAlert();
    this.customAlertService.dismissed().subscribe();
  }

  private hideAlert() {
    this.show = false;
    this.remember.setWithExpiry(this.hideAlertKey, true, this.fifteenMinutes);
  }

  private isHidden(): boolean {
    return Boolean(this.remember.getWithExpiry(this.hideAlertKey));
  }
}
